import { Helmet } from 'react-helmet';

import HeroSectionImage from '../../images/HomePage/HeroSection/HH25_HeroSectionImage.png'
import Icon1 from '../../images/HomePage/HH25_Home_Section2_Icon1.svg'
import Icon2 from '../../images/HomePage/HH25_Home_Section2_Icon2.svg'
import Icon3 from '../../images/HomePage/HH25_Home_Section2_Icon3.svg'
import Icon4 from '../../images/HomePage/HH25_Home_Section2_Icon4.svg'
import Bg1 from '../../images/HomePage/HH25_Home_Section2_Background1.svg'
import Bg2 from '../../images/HomePage/HH25_Home_Section2_Background2.svg'
import Bg3 from '../../images/HomePage/HH25_Home_Section2_Background3.svg'
import Bg4 from '../../images/HomePage/HH25_Home_Section2_Background4.svg'
import HeroSection3Bg from '../../images/HomePage/HH25_HeroSection3_BackgroundImage.png';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import TestimonialCamila from '../../images/HomePage/HH25_Home_Section2_Background1.svg';
import TestimonialRosa from '../../images/HomePage/HH25_Home_Section2_Background1.svg';
import TestimonialFlorencia from '../../images/HomePage/HH25_Home_Section2_Background1.svg';
import TestimonialLucia from '../../images/HomePage/HH25_Home_Section2_Background1.svg';


import TestimonialsBg from '../../images/HomePage/HH25_HeroSection4_BackgroundImage.png';
import HH25HeroSection5Line from '../../images/HomePage/HH25_HeroSection5_Line.svg';

const HomePage = ({ setSignUpVisible }) => {
  const navigate = useNavigate();

  /* 
  // TEMPORAL: Redirige al mantenimiento. Eliminar cuando termine el mantenimiento.
  useEffect(() => {
    navigate('/maintenance', { replace: true });
  }, [navigate]);
  */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          }
        });
      },
      { threshold: 0.2 }
    );

    const sections = document.querySelectorAll('.fade-in');
    sections.forEach(section => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <Helmet>
        <title>HappyHome - Tu Solución Integral para el Hogar</title>
        <meta name="description" content="La forma más fácil, rápida y económica de encontrar ayuda integral para tu hogar en Argentina. Ofrecemos servicios de empleada doméstica, niñeras, cuidadores de personas mayores, cuidadores de mascotas y cocineros." />
        <meta name="keywords" content="ayuda en el hogar, empleada doméstica, niñera, cuidador de personas mayores, cuidador de mascotas, cocinera" />
        <meta property="og:title" content="HappyHome - Tu Solución Integral para el Hogar" />
        <meta property="og:description" content="La forma más fácil, rápida y económica de encontrar ayuda integral para tu hogar." />
        <meta property="og:image" content={HeroSectionImage} />
        <meta property="og:url" content="http://www.happyhome.com.ar" />
      </Helmet>

      <div className="hero-section fade-in">
        <div className="hero-bg-image">
          <img src={HeroSectionImage} alt="HappyHome HeroImage" />
          <div className="container-max-width">
            <div className="hero-titles">
              <h1 className="hero-main-title">
                Cuidamos <span className="hero-main-title-italic">tu hogar</span>,<br />
                Impulsamos <span className="hero-main-title-italic">oportunidades</span>.
              </h1>
              <div className="hero-subtitle-block">
                <h2 className="hero-subtitle">¿QUÉ ESTÁS BUSCANDO?</h2>
                <div className="hero-buttons-row">
                  <button className="hero-btn hero-btn-primary">QUIERO CONTRATAR PERSONAL</button>
                  <button className="hero-btn hero-btn-secondary">ESTOY BUSCANDO TRABAJO</button>
                </div>
                <div className="hero-descriptions-row">
                  <div className="hero-desc">Buscá perfiles, filtrá por tareas, zona y horarios, y contactá directamente.</div>
                  <div className="hero-desc">Cargá tu experiencia, aplicá a ofertas y empezá a conectarte con empleadores.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="features-section fade-in">
        <div className="features-header container-max-width">
          <h2 className="features-title">
            En cada necesidad, <span className="features-highlight"><em>hay esperanza</em></span>. En cada encuentro, <span className="features-highlight"><em>una posibilidad</em></span>.
          </h2>
        </div>
        <div className="features-grid container-max-width">
          <div className="feature-card" style={{ backgroundImage: `url(${Bg1})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover' }}>
            <div className="feature-icon">
              <img src={Icon1} alt="Conexiones reales" />
            </div>
            <div className="feature-card-content">
              <h3 className="feature-card-title">+10.000 Conexiones reales</h3>
              <p className="feature-card-description">Familias, empresas<br/>y trabajadores de todo el país.</p>
            </div>
          </div>
          <div className="feature-card" style={{ backgroundImage: `url(${Bg2})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover' }}>
            <div className="feature-icon">
              <img src={Icon2} alt="Plataforma transparente" />
            </div>
            <div className="feature-card-content">
              <h3 className="feature-card-title">Plataforma transparente</h3>
              <p className="feature-card-description">Cuidamos cada conexión.</p>
            </div>
          </div>
          <div className="feature-card" style={{ backgroundImage: `url(${Bg3})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover' }}>
            <div className="feature-icon">
              <img src={Icon3} alt="Disponible en todo el país" />
            </div>
            <div className="feature-card-content">
              <h3 className="feature-card-title">Disponible en todo el país</h3>
              <p className="feature-card-description">Desde grandes ciudades<br/>hasta pueblos del interior.</p>
            </div>
          </div>
          <div className="feature-card" style={{ backgroundImage: `url(${Bg4})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover' }}>
            <div className="feature-icon">
              <img src={Icon4} alt="Capacitación para crecer" />
            </div>
            <div className="feature-card-content">
              <h3 className="feature-card-title">Capacitación para crecer</h3>
              <p className="feature-card-description">Accedé a talleres, manuales<br/>y recursos para mejorar tus oportunidades.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Nueva sección: ¿Qué podés encontrar en HappyHome? */}
      <section className="hh-what-section fade-in">
        <div className="hh-what-bg" style={{ backgroundImage: `url(${HeroSection3Bg})` }}>
          <div className="hh-what-cols">
            <div className="hh-what-col-empty"></div>
            <div className="hh-what-content">
              <h2 className="hh-what-title">
                ¿Qué podés encontrar<br />en <span className="hh-what-title-bold">HappyHome</span><span className="hh-what-title-reg">&nbsp;?</span>
              </h2>
              <div className="hh-what-tags">
                <div className="hh-what-tags-row">
                  <span className="hh-tag hh-tag-yellow">NIÑERAS</span>
                  <span className="hh-tag hh-tag-purple">COCINEROS/AS</span>
                </div>
                <div className="hh-what-tags-row">
                  <span className="hh-tag hh-tag-pink">EMPLEADAS DOMÉSTICAS</span>
                </div>
                <div className="hh-what-tags-row">
                  <span className="hh-tag hh-tag-yellow">CUIDADORES/AS DE MASCOTAS</span>
                </div>
                <div className="hh-what-tags-row">
                  <span className="hh-tag hh-tag-purple">CUIDADORES/AS DE PERSONAS MAYORES</span>
                </div>
                <div className="hh-what-tags-row">
                  <span className="hh-tag hh-tag-yellow hh-tag-wide">PERSONAL DE LIMPIEZA Y MANTENIMIENTO<br />PARA EMPRESAS Y CORPORACIONES</span>
                </div>
              </div>
            </div>
          </div>
          <div className="hh-what-bottom-border"></div>
        </div>
      </section>

      {/* Testimonios y Casos Reales */}
      <section className="testimonials-section fade-in">
        <div
          className="testimonials-bg"
          style={{ backgroundImage: `url(${TestimonialsBg})` }}
        >
          <div className="testimonials-header">
            <h2>
              Testimonios y casos
              <span className="testimonials-highlight">reales</span>
            </h2>
          </div>
          <div className="testimonials-grid">
            {/* Camila */}
            <div className="testimonial-card">
              <img src={TestimonialCamila} alt="Camila" className="testimonial-img" />
              <div className="testimonial-content">
                <div className="testimonial-name">Camila</div>
                <div className="testimonial-role">Estudiante y niñera.</div>
                <div className="testimonial-text">
                  “Estoy estudiando y necesitaba un trabajo que me permitiera mantener la cursada. Armé mi perfil, conté mi disponibilidad y me contactaron al toque. Estoy trabajando con una familia re buena, con horarios que se adaptan a mí.”
                </div>
              </div>
            </div>
            {/* Rosa */}
            <div className="testimonial-card">
              <img src={TestimonialRosa} alt="Rosa" className="testimonial-img" />
              <div className="testimonial-content">
                <div className="testimonial-name">Rosa</div>
                <div className="testimonial-role">Limpieza en edificio.</div>
                <div className="testimonial-text">
                  “Siempre hice limpieza en casas, pero esta vez me animé a buscar algo distinto. Cargué mi experiencia y me ofrecieron trabajar en un edificio. Estoy contenta: tengo horarios fijos, un sueldo en blanco y un ambiente tranquilo. Me tratan bien y valió la pena animarse.”
                </div>
              </div>
            </div>
            {/* Florencia */}
            <div className="testimonial-card">
              <img src={TestimonialFlorencia} alt="Florencia" className="testimonial-img" />
              <div className="testimonial-content">
                <div className="testimonial-name">Florencia</div>
                <div className="testimonial-role">Cuidadora y cocinera</div>
                <div className="testimonial-text">
                  “Siempre trabajé en casas, pero nunca había tenido un lugar donde pudiera mostrar bien lo que hago. Subí mi experiencia, mis referencias y en pocos días me contactó una familia. Me trataron con respeto desde el primer mensaje.”
                </div>
              </div>
            </div>
            {/* Lucía */}
            <div className="testimonial-card">
              <img src={TestimonialLucia} alt="Lucía" className="testimonial-img" />
              <div className="testimonial-content">
                <div className="testimonial-name">Lucía</div>
                <div className="testimonial-role">Empleadora en CABA</div>
                <div className="testimonial-text">
                  “Necesitaba una persona con cama para cuidar a mi mamá. Probé muchas opciones, pero nada funcionaba. Acá fue todo más claro. Me sentí acompañada en el proceso y encontré a alguien que se ocupa con cariño y responsabilidad.”
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Última sección CTA */}
      <section className="cta-section fade-in">
        <div className="cta-bg">
          <div className="cta-content">
            <div className="cta-title-row">
              <span className="cta-title">CUIDAMOS LO QUE MÁS IMPORTA</span>
              <button className="cta-btn">PROBALO HOY</button>
            </div>
            <img src={HH25HeroSection5Line} alt="Decorative underline" className="cta-underline" />
          </div>
        </div>
      </section>

    </div>
  );
};

export default HomePage;
